import { any, func, oneOfType, shape } from 'prop-types';

export const refType = oneOfType([
  func,
  // eslint-disable-next-line react/forbid-prop-types
  shape({ current: any }),
]);
